module.exports = __webpack_public_path__ + "assets/b63c5009b083b09df7da08c8bd3a0595.png";